import { render } from "./CompleteFitOverlayConfirm.vue?vue&type=template&id=23b9944a&lang=pug"
import script from "./CompleteFitOverlayConfirm.vue?vue&type=script&lang=js"
export * from "./CompleteFitOverlayConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__